import * as React from 'react';
import type { SectionBackgroundPropsType } from './types';

const SectionBackground: React.FC<SectionBackgroundPropsType> = ( props: SectionBackgroundPropsType ) => (
    <div
        id={ props.anchorName }
        data-background-url={ props.backgroundUrl }
        data-url={ props.url }
        className='SectionBackground invisible max-h-[440px] w-full bg-white'
    >
        <div
            className='SectionBackground-fixedHelper h-[440px] w-full bg-[#fafafa] bg-no-repeat bg-top max-[1100px]:h-[348px] max-[700px]:h-[110px]! max-[700px]:bg-center'
            style={ { backgroundImage: `url(${ props.url })`, backgroundPosition: 'center -21px' } }
        />
    </div>
);

export { SectionBackground };
